"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgInsuranceOff = function SvgInsuranceOff(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.191 1.496a1.375 1.375 0 1 0-1.945 1.945l18.782 18.781a1.375 1.375 0 0 0 1.944-1.944l-2.692-2.692a11.415 11.415 0 0 0 2.294-6.727c.003-.212.005-.427.005-.646 0-2.29-.18-4.386-.314-5.619-.1-.929-.678-1.804-1.712-2.034-1.185-.265-3.425-.56-7.549-.56-4.123 0-6.363.295-7.548.56a2.26 2.26 0 0 0-.16.041L3.191 1.496Zm6.716 6.716 5.034 5.035c.536-.012.954-.026 1.26-.039.409-.016.755-.278.817-.682.05-.325.093-.779.093-1.377s-.043-1.052-.093-1.377c-.063-.404-.408-.666-.816-.682a78.33 78.33 0 0 0-2.085-.054 82.324 82.324 0 0 0-.053-2.084c-.017-.408-.279-.754-.682-.816a9.11 9.11 0 0 0-1.377-.093 9.11 9.11 0 0 0-1.378.093c-.403.062-.665.408-.682.816-.012.307-.026.724-.038 1.26Zm-7.477 2c0-1.268.055-2.477.127-3.513l13.606 13.682c-.7.424-1.42.814-2.1 1.104-.703.299-1.42.515-2.059.515-.638 0-1.355-.216-2.057-.515-.714-.303-1.47-.717-2.202-1.165-3.3-2.02-5.254-5.612-5.31-9.46a44.03 44.03 0 0 1-.005-.647Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgInsuranceOff);
var _default = exports["default"] = Memo;